<template>
    <v-container fluid class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.ibeaconSetting.messages') }}
        </div>

        <v-card>
            <v-card-text class="pb-1">
                <v-row>
                    <v-col cols="4">
                        <v-text-field
                            outlined
                            hide-details
                            height="40px"
                            append-icon="search"
                            v-model="search"
                            :placeholder="
                                $t('placeholder.filterByMessageIdAndTopic')
                            "
                        />
                    </v-col>
                    <v-col class="px-0" cols="3">
                        <date-range-field
                            class="mx-4"
                            v-model="dateRange"
                            @change="onDateRangeChanged"
                        />
                    </v-col>
                    <v-col>
                        <v-btn
                            class="float-right"
                            color="primary"
                            @click="createIBeaconMessage">
                            {{ $t('button.createMessage') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <i-beacon-message-list-view
                class="i-beacon-message-list-view"
                ref="ibeaconMessageListView"
                :search="search"
                :messages="messages"
                :pagination="pagination"
            />
        </v-card>

        <v-pagination
            v-show="showPagination"
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="page"
            :length="pageTotal"
            :total-visible="totalVisible"
            @input="onPaginationChanged"/>
    </v-container>
</template>

<script>
import IBeaconMessageListView from '@/views/lists/IBeaconMessageListView'
import DateRangeField from '@/components/fields/DateRangeField'
import PaginationMixin from '@/mixins/PaginationMixin'

import { mapState } from 'vuex'

export default {
    name: 'IBeaconMessageListPage',

    mixins: [PaginationMixin],

    components: {
        DateRangeField,
        IBeaconMessageListView
    },

    data () {
        return {
            search: '',
            dateRange: []
        }
    },

    computed: {
        ...mapState('ibeaconMessage', ['messages', 'total'])
    },

    mounted () {
        this.fetchIBeaconMessage()
    },

    methods: {
        getQueryObject () {
            return {
                page: this.page,
                itemsPerPage: this.itemsPerPage,
                sortBy: this.sortBy,
                sortType: this.sortType,
                from: this.dateRange.length === 2 ? this.dateRange[0] : undefined,
                to: this.dateRange.length === 2 ? this.dateRange[1] : undefined
            }
        },

        fetchIBeaconMessage () {
            this.$store.dispatch('ibeaconMessage/fetchIBeaconMessages', this.getQueryObject())
        },

        createIBeaconMessage () {
            this.$refs.ibeaconMessageListView.openCreateIBeaconMessagePanel()
        },

        onDateRangeChanged () {
            this.fetchIBeaconMessage()
        },

        onPaginationChanged (value) {
            this.page = value
            this.fetchIBeaconMessage()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
